import React from "react";
import { QRCodeSVG } from "qrcode.react";

const benefits = [
  "اختاري طبختك بسهولة",
  "احصل على المقادير المناسبة",
  "وفّري وقت التسوق والتحضير",
];

function StepsSection() {
  return (
    <section
      dir="rtl"
      className="
        w-full
        box-border
        relative
        z-[1]
        overflow-hidden

        bg-[#F8ECE5]
        font-['Cairo']

        px-20
        py-20

        max-[1000px]:px-[60px]
        max-[1000px]:py-[60px]

        max-[900px]:px-10
        max-[900px]:py-[60px]

        max-[650px]:px-5
        max-[650px]:py-[50px]
      "
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-16 top-10 h-48 w-48 rounded-full bg-[#D40C1A]/10 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-10 bottom-8 h-40 w-40 rounded-full bg-[#D40C1A]/10 blur-3xl"
      />

      <div
        className="
          w-full
          max-w-[1000px]
          mx-auto

          flex
          flex-row
          items-center
          justify-center
          gap-[60px]

          box-border
          relative
          bg-white/80
          border
          border-white
          rounded-[28px]
          px-12
          py-12
          shadow-[0_16px_40px_rgba(120,32,24,0.08)]

          max-[1000px]:gap-[50px]
          max-[1000px]:px-8
          max-[1000px]:py-10

          max-[900px]:gap-9
          max-[900px]:px-7

          max-[650px]:flex-col
          max-[650px]:gap-8
          max-[650px]:items-center
          max-[650px]:px-5
          max-[650px]:py-8
          max-[650px]:rounded-[22px]
        "
      >
        <div
          dir="rtl"
          className="
            flex-1
            min-w-0

            flex
            flex-col
            gap-[14px]

            box-border

            text-right

            max-[650px]:w-full
            max-[650px]:items-center
            max-[650px]:text-center
          "
        >
          <h2
            className="
              m-0
              font-['Cairo']
              text-[32px]
              font-extrabold
              leading-[1.3]
              tracking-[-0.36px]
              text-[#281D14]

              text-right
              w-full
              animate-fade-up

              max-[1000px]:text-[26px]

              max-[900px]:text-[22px]

              max-[650px]:text-[22px]
              max-[650px]:text-center
            "
            style={{ animationDelay: "80ms" }}
          >
            طبختنا معك بكل خطوة
          </h2>

          <p
            className="
              m-0
              font-['Cairo']
              text-[15px]
              font-normal
              leading-[1.7]
              text-[#705B55]

              text-right

              max-w-[480px]
              w-full
              animate-fade-up

              max-[1000px]:text-sm

              max-[650px]:text-center
              max-[650px]:max-w-full
            "
            style={{ animationDelay: "160ms" }}
          >
            من اختيار الوجبة وحتى وصول المكونات إلى باب منزلك، تطبيق طبختنا
            يجعل تجربة الطبخ أسهل وأسرع وأكثر تنظيماً
          </p>

          <ul className="m-0 p-0 list-none flex flex-col gap-2.5">
            {benefits.map((text, index) => (
              <li
                key={text}
                dir="rtl"
                className="
                  flex
                  flex-row
                  items-center
                  justify-start
                  gap-2.5

                  font-['Cairo']
                  text-sm
                  font-semibold
                  text-[#281D14]
                  animate-fade-up

                  max-[650px]:justify-center
                "
                style={{ animationDelay: `${240 + index * 90}ms` }}
              >
                <span className="w-[22px] h-[22px] shrink-0 rounded-full bg-[#D40C1A] text-white flex items-center justify-center font-['Cairo'] text-[11px] font-bold leading-none shadow-[0_4px_10px_rgba(212,12,26,0.25)]">
                  ✓
                </span>
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="shrink-0 flex flex-col items-center gap-3 animate-float-slow">
          <div className="relative">
            <div
              aria-hidden="true"
              className="
                absolute
                -inset-4
                rounded-full
                border
                border-dashed
                border-[#D40C1A]/35
                animate-qr-spin
              "
            />
            <div
              className="
                relative
                w-[240px]
                h-[240px]
                shrink-0

                box-border
                border
                border-[#f3ddd8]

                bg-white

                flex
                items-center
                justify-center

                p-[14px]

                rounded-[18px]
                shadow-[0_12px_30px_rgba(120,32,24,0.12)]

                max-[1000px]:w-[200px]
                max-[1000px]:h-[200px]
                max-[1000px]:p-[11px]

                max-[900px]:w-[180px]
                max-[900px]:h-[180px]
                max-[900px]:p-[10px]

                max-[650px]:w-[180px]
                max-[650px]:h-[180px]
                max-[650px]:p-[10px]
              "
            >
              <QRCodeSVG
                value="https://drive.google.com/file/d/1fR0Y8SZtLdrb8lKyMJfWuMeVlEYnRR7S/view"
                size={232}
                level="H"
                className="
                  w-[212px]
                  h-[212px]

                  max-[1000px]:w-[178px]
                  max-[1000px]:h-[178px]

                  max-[900px]:w-40
                  max-[900px]:h-40

                  max-[650px]:w-40
                  max-[650px]:h-40
                "
              />
            </div>
          </div>
          <p className="m-0 text-[12px] font-semibold text-[#D40C1A]">
             للتحميل
          </p>
        </div>
      </div>
    </section>
  );
}

export default StepsSection;
